import { Component, Input } from '@angular/core';
import { NbComponentStatus } from '@nebular/theme';

@Component({
  standalone: false,
  selector: 'wr-confirm-dialog',
  templateUrl: './generic-dialog.component.html',
})
export class GenericDialogComponent {
  @Input()
  header: string = '';
  @Input()
  message: string = '';
  @Input()
  status: NbComponentStatus = 'primary';
}
